import 'jspdf-autotable';

/**
 * Gera o cabeçalho do PDF com informações do usuário, data, hora e número de páginas.
 * @param {Object} doc - Instância do jsPDF.
 * @param {string} reportTitle - Título do relatório.
 * @param {string} userName - Nome do usuário.
 * @param {string} filters - Filtros aplicados no relatório.
 * @param {number} recordCount - Número total de registros.
 * @param {number} pageNumber - Número da página atual.
 * @param {number} totalPages - Número total de páginas.
 * @returns {number} - Altura do cabeçalho.
 */
const generatePDF = (doc, reportTitle, userName, filters, recordCount, pageNumber, totalPages) => {
  const currentDate = new Date().toLocaleDateString('pt-BR');
  const currentTime = new Date().toLocaleTimeString('pt-BR');

  const addHeader = () => {
    doc.setFontSize(10);
    doc.setTextColor(40);
    doc.setFont('helvetica', 'normal');
    // user and date on first lines
    doc.text(`Usuário: ${userName}`, 14, 12);
    doc.text(`Data/Hora: ${currentDate} ${currentTime}`, doc.internal.pageSize.width - 14, 12, { align: 'right' });
    // page number on the right, slightly lower
    doc.text(`Página ${pageNumber} de ${totalPages}`, doc.internal.pageSize.width - 14, 20, { align: 'right' });
    doc.setLineWidth(0.1);
    doc.line(14, 24, doc.internal.pageSize.width - 14, 24);
  };

  const addTitle = () => {
    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.text(reportTitle, doc.internal.pageSize.width / 2, 16, { align: 'center' });
  };

  const addFiltersAndRecordCount = () => {
    doc.setFontSize(9);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(0);
    doc.text(`Filtros: ${filters}`, 14, 28);
    doc.text(`Total de Registros: ${recordCount}`, doc.internal.pageSize.width - 14, 28, { align: 'right' });
  };

  addHeader();
  addTitle();
  addFiltersAndRecordCount();

  return 32; 
};

/**
 * Finaliza o PDF adicionando cabeçalhos em todas as páginas.
 * @param {Object} doc - Instância do jsPDF.
 * @param {string} userName - Nome do usuário.
 * @param {string} filters - Filtros aplicados.
 * @param {number} recordCount - Número total de registros.
 * @param {string} reportTitle - Título do relatório.
 */
const finalizePDF = (doc, userName, filters, recordCount, reportTitle) => {
  const totalPages = doc.internal.getNumberOfPages();
  for (let i = 1; i <= totalPages; i++) {
    doc.setPage(i);
    // generate the header/title/filters
    generatePDF(doc, reportTitle, userName, filters, recordCount, i, totalPages);
    // add footer watermark right-aligned, small and light so it doesn't overlap
    doc.setFontSize(9);
    doc.setTextColor(150);
    doc.setFont('helvetica', 'normal');
    const w = doc.internal.pageSize.getWidth();
    const h = doc.internal.pageSize.getHeight();
    doc.text('Emitido pelo Sistema INNOVA', w - 14, h - 8, { align: 'right' });
  }
};

export { generatePDF, finalizePDF };
export default generatePDF;